import CaseOwnerProfileModal from "@/components/config_components/CaseOwnerProfileModal/CaseOwnerProfileModal.vue";
import BlockingLoaderOverlay from '@/components/config_components/BlockingLoaderOverlay/BlockingLoaderOverlay.vue';
import axios from 'axios';
import alert_mixin from "@/utils/mixins/alert_mixin";
import { clear_auth_storage } from '@/utils/auth/session_manager';
import {
  GET_USER_ROLES,
  GET_USERS,
  LAUNCH_PLATFORM_URL,
  UPDATE_USER,
  get_headers,
  get_request_config,
} from '@/utils/system_constants/constant';
import { fetch_requestor_entity_profiles, fetch_requestor_entity_types } from '@/services/requestor_portal_service';
import {
  fetch_company_cases,
  fetch_open_company_case_count,
  fetch_coordinator_assigned_company_cases,
  fetch_open_coordinator_assigned_company_cases,
} from '@/views/x-verdict_views/CompanyAdmin/CompanyCases/company_cases_live_queue';
import {
  current_user_id as inbox_current_user_id,
  current_user_mention_tokens,
  unique_cases,
  visible_cases_for_role,
} from '@/views/x-verdict_views/CompanyAdmin/CompanyInboxes/company_inbox';
import {
  note_authored_by_current_user,
  note_mentions_current_user,
} from '@/views/x-verdict_views/CompanyAdmin/CompanyInboxes/company_inbox_helpers';
import {
  fetch_intake_cases,
} from '@/views/x-verdict_views/IntakeOfficer/intake_case_queue_service';
import {
  fetch_case_owner_cases,
  fetch_case_owner_status_items,
} from '@/views/x-verdict_views/CaseOwner/AllCases/owner_case_queue_service';
import { create_requestor_case, fetch_requestor_application_notes } from '@/services/requestor_portal_service';
import { fetch_scoped_entity_types } from '@/views/x-verdict_views/CompanyAdmin/CompanyCases/company_cases_response_helpers';
import { get_entity_type_name, normalize_text, to_number } from '@/views/x-verdict_views/CompanyAdmin/CompanyCases/company_cases_helpers';
import {
  created_manual_case,
  resolve_manual_case_form_ids,
} from '@/views/x-verdict_views/IntakeOfficer/manual_case_form_helpers';
import {
  load_timesheet_sheets,
  timesheet_months,
} from '@/views/x-verdict_views/CompanyAdmin/TimeSheets/time_sheets_helpers';
import {
  is_active_case_status,
  record_status_label,
} from '@/views/x-verdict_views/Requestor/RequestorPortal/request_portal_helpers';
import {
  map_panel_member,
  map_role,
  panel_member_is_allowed,
  response_items,
} from '@/views/x-verdict_views/CompanyAdmin/PanelRegister/panel_register_helpers';
import {
  build_case_owner_profile,
  build_case_owner_work_items,
  build_requestor_work_items,
  build_coordinator_work_items,
  build_intake_officer_work_items,
  COMPANY_ADMIN_SIDEBAR_GROUPS,
  is_active_route,
  is_admin_role,
  is_case_owner_role,
  is_coordinator_role,
  is_intake_officer_role,
  is_requestor_role,
  route_project_id,
} from './config_sidebar_helpers';

export default {
  name: 'ConfigGlobalSidebar',
  mixins: [alert_mixin],
  components: {
    CaseOwnerProfileModal,
    BlockingLoaderOverlay,
  },
  data: () => ({
    show_case_owner_profile_modal: false,
    coordinator_scope_case_count: null,
    coordinator_panel_count: null,
    intake_queue_count: null,
    intake_registered_case_count: null,
    intake_inbox_count: null,
    case_owner_case_count: null,
    case_owner_inbox_count: null,
    case_owner_dynamic_status_items: [],
    case_owner_user_profile: null,
    case_owner_profile_save_version: 0,
    requestor_case_count: null,
    requestor_inbox_count: null,
    coordinator_inbox_count: null,
    show_coordinator_register_modal: false,
    coordinator_timesheet_count: null,
    coordinator_manual_case: coordinator_manual_case_form(),
    coordinator_case_type_options: [],
    submitting_coordinator_manual_case: false,
    coordinator_manual_case_error: '',
  }),
  computed: {
    sidebar_groups() {
      return COMPANY_ADMIN_SIDEBAR_GROUPS
        .map((group) => ({
          ...group,
          items: group.items.filter((item) => !item.admin_only || this.is_admin_role),
        }))
        .filter((group) => group.items.length);
    },
    current_role() {
      return (
        this.$store.getters.currentRole
        || sessionStorage.getItem('current_role')
        || sessionStorage.getItem('user_role')
        || ''
      );
    },
    is_admin_role() {
      return is_admin_role(this.current_role);
    },
    current_lead_name() {
      return this.$store.getters.currentLeadName || '';
    },
    current_project_name() {
      return this.$store.getters.currentProjectName || '';
    },
    sidebar_meta_line() {
      return ['ROLE', this.current_role]
        .map((value) => String(value || '').trim())
        .filter(Boolean)
        .join(' - ');
    },
    route_project_id() {
      return route_project_id(this.$route);
    },
    current_project_query() {
      return this.route_project_id
        ? { project_id: String(this.route_project_id) }
        : {};
    },
    project_sidebar_meta_line() {
      return this.current_project_name;
    },
    uses_case_owner_sidebar() {
      return is_case_owner_role(this.current_role);
    },
    uses_requestor_sidebar() {
      return is_requestor_role(this.current_role);
    },
    uses_intake_officer_sidebar() {
      return is_intake_officer_role(this.current_role);
    },
    uses_coordinator_sidebar() {
      return is_coordinator_role(this.current_role);
    },
    case_owner_profile() {
      return build_case_owner_profile({
        current_lead_name: this.current_lead_name,
        current_role: this.current_role,
        current_project_name: this.current_project_name,
        user_profile: this.case_owner_user_profile,
        case_count: this.case_owner_case_count,
        inbox_count: this.case_owner_inbox_count,
        status_items: this.case_owner_dynamic_status_items,
      });
    },
    case_owner_work_items() {
      return build_case_owner_work_items(
        this.case_owner_case_count,
        this.case_owner_inbox_count
      );
    },
    case_owner_status_items() {
      return this.case_owner_dynamic_status_items;
    },
    requestor_work_items() {
      return build_requestor_work_items(
        this.requestor_case_count,
        this.requestor_inbox_count
      );
    },
    intake_officer_work_items() {
      return build_intake_officer_work_items(
        this.intake_queue_count,
        this.intake_registered_case_count,
        this.intake_inbox_count
      );
    },
    coordinator_work_items() {
      return build_coordinator_work_items(
        this.coordinator_scope_case_count,
        this.intake_queue_count,
        this.coordinator_inbox_count,
        this.coordinator_panel_count,
        this.coordinator_timesheet_count
      );
    }
  },
  watch: {
    current_role: {
      immediate: true,
      handler() {
        this.refresh_coordinator_sidebar_counts();
        this.refresh_intake_officer_sidebar_counts();
        this.refresh_case_owner_sidebar_items();
        this.refresh_case_owner_user_profile();
        this.refresh_requestor_sidebar_counts();
        this.load_coordinator_case_type_options();
      }
    },
    route_project_id() {
      this.refresh_coordinator_sidebar_counts();
      this.refresh_intake_officer_sidebar_counts();
      this.refresh_case_owner_sidebar_items();
      this.refresh_case_owner_user_profile();
      this.refresh_requestor_sidebar_counts();
      this.load_coordinator_case_type_options();
    }
  },
  methods: {
    async load_coordinator_case_type_options() {
      if (!this.uses_coordinator_sidebar && !this.uses_case_owner_sidebar && !this.uses_intake_officer_sidebar) {
        this.coordinator_case_type_options = [];
        this.coordinator_manual_case.case_type = '';
        return;
      }

      const response = await fetch_scoped_entity_types(this.route_project_id).catch(() => null);
      const entity_types = response?.entity_types || [];

      this.coordinator_case_type_options = entity_types
        .map((entity_type) => ({
          id: String(entity_type?.id || ''),
          label: get_entity_type_name(entity_type),
          form_ids: Array.isArray(entity_type?.form_ids) ? entity_type.form_ids : [],
        }))
        .filter((option) => option.id && option.label);

      if (!this.coordinator_manual_case.case_type && this.coordinator_case_type_options[0]?.id) {
        this.coordinator_manual_case.case_type = String(this.coordinator_case_type_options[0].id);
      }
    },
    async refresh_intake_officer_sidebar_counts() {
      if (!this.uses_intake_officer_sidebar && !this.uses_case_owner_sidebar) {
        this.intake_queue_count = null;
        this.intake_registered_case_count = null;
        this.intake_inbox_count = null;
        return;
      }

      const [intake_cases, registered_case_count] = await Promise.all([
        fetch_intake_cases(this.route_project_id),
        fetch_open_company_case_count(this.route_project_id),
      ]).catch(() => [null, null]);

      this.intake_queue_count = Array.isArray(intake_cases)
        ? intake_cases.filter((case_item) => case_is_in_intake_queue(case_item)).length
        : null;
      this.intake_registered_case_count = registered_case_count;
      this.intake_inbox_count = Array.isArray(intake_cases)
        ? intake_cases.filter((case_item) => case_requires_attention(case_item)).length
        : null;
    },
    async refresh_case_owner_sidebar_items() {
      if (!this.uses_case_owner_sidebar) {
        this.case_owner_case_count = null;
        this.case_owner_inbox_count = null;
        this.case_owner_dynamic_status_items = [];
        return;
      }

      const [status_items, cases] = await Promise.all([
        fetch_case_owner_status_items(this.route_project_id),
        fetch_case_owner_cases(this.route_project_id),
      ]).catch(() => [null, null]);

      if (!status_items || !cases) {
        this.case_owner_case_count = null;
        this.case_owner_inbox_count = null;
        this.case_owner_dynamic_status_items = [];
        return;
      }

      const mention_count = await fetch_sidebar_mention_count(this, cases).catch(() => 0);

      this.case_owner_dynamic_status_items = status_items;
      this.case_owner_case_count = cases.length;
      this.case_owner_inbox_count = cases.filter((case_item) => case_requires_attention(case_item)).length + mention_count;
    },
    async refresh_case_owner_user_profile() {
      if (!this.uses_case_owner_sidebar) {
        this.case_owner_user_profile = null;
        return;
      }

      const current_user_id = Number(
        this.$store?.getters?.currentUserId
        || sessionStorage.getItem('current_user_id')
        || sessionStorage.getItem('user_id')
        || 0
      );

      if (!current_user_id) {
        this.case_owner_user_profile = null;
        return;
      }

      const users = await fetch_sidebar_panel_users(this.current_role).catch(() => []);
      this.case_owner_user_profile = users.find((profile) =>
        Number(profile?.user_id || profile?.user?.id || 0) === current_user_id
      ) || null;
    },
    async refresh_requestor_sidebar_counts() {
      if (!this.uses_requestor_sidebar) {
        this.requestor_case_count = null;
        this.requestor_inbox_count = null;
        return;
      }

      const cases = await fetch_requestor_sidebar_cases(this.route_project_id).catch(() => null);
      if (!Array.isArray(cases)) {
        this.requestor_case_count = null;
        this.requestor_inbox_count = null;
        return;
      }

      const mention_count = await fetch_sidebar_mention_count(this, cases).catch(() => 0);

      this.requestor_case_count = cases.length;
      this.requestor_inbox_count = cases.filter((case_item) => case_requires_attention(case_item)).length + mention_count;
    },
    async refresh_coordinator_sidebar_counts() {
      if (!this.uses_coordinator_sidebar) {
        this.coordinator_scope_case_count = null;
        this.coordinator_inbox_count = null;
        this.coordinator_panel_count = null;
        this.coordinator_timesheet_count = null;
        return;
      }

      const [
        open_cases,
        inbox_count,
        panel_count,
        timesheet_count,
      ] = await Promise.all([
        fetch_open_coordinator_assigned_company_cases(this.route_project_id)
          .catch(() => null),
        fetch_coordinator_inbox_count(this, this.route_project_id, this.current_role).catch(() => null),
        fetch_panel_member_count(this.current_role).catch(() => null),
        fetch_timesheet_count(this.route_project_id).catch(() => null),
      ]);

      this.coordinator_scope_case_count = Array.isArray(open_cases) ? open_cases.length : null;
      this.coordinator_inbox_count = inbox_count;
      this.coordinator_panel_count = panel_count;
      this.coordinator_timesheet_count = timesheet_count;
    },
    build_sidebar_route(item) {
      const query = {
        ...this.current_project_query,
        ...(item?.route_query || {})
      };

      return Object.keys(query).length
        ? { name: item.route_name, query }
        : { name: item.route_name };
    },
    async go_to_config_system() {
      if (!this.is_admin_role) return;

      await this.launch_platform('config');
    },
    async launch_platform(platform) {
      const external_user_id = sessionStorage.getItem('user_id')
        || sessionStorage.getItem('current_user_id');

      try {
        const response = await axios.post(
          LAUNCH_PLATFORM_URL,
          { platform, external_user_id },
          { headers: get_headers() }
        );
        const response_data = response.data || {};

        if (response_data.redirect_url) {
          window.location.href = response_data.redirect_url;
          return;
        }

        this.show_error('Failed to launch platform: No redirect URL provided');
      } catch (error) {
        if (error.response?.status === 403) {
          this.show_error('Access denied to this platform');
        } else if (error.response?.status === 404) {
          this.show_error('Platform not found or unavailable');
        } else {
          this.show_error('Failed to launch platform');
        }
      }
    },
    sign_out() {
      clear_auth_storage();
      this.$store.dispatch('resetStore');
      this.$router.push({ name: 'UserLogin' });
    },
    close_sidebar() {
      if (window.innerWidth < 992) {
        this.$emit('close');
      }
    },
    open_case_owner_profile_modal() {
      this.show_case_owner_profile_modal = true;
      this.refresh_case_owner_user_profile();
    },
    go_to_requestor_new_case() {
      this.$router.push({ name: 'RequestorPortal' });
      this.close_sidebar();
    },
    go_to_case_owner_intake_queue() {
      this.$router.push({
        name: 'IntakeDesk',
        query: {
          ...this.current_project_query,
        },
      });
      this.close_sidebar();
    },
    go_to_company_new_case() {
      this.coordinator_manual_case = coordinator_manual_case_form();
      if (this.coordinator_case_type_options[0]?.id) {
        this.coordinator_manual_case.case_type = String(this.coordinator_case_type_options[0].id);
      }
      this.show_coordinator_register_modal = true;
      this.coordinator_manual_case_error = '';
      this.close_sidebar();
    },
    go_to_coordinator_new_case() {
      this.go_to_company_new_case();
    },
    close_coordinator_register_modal() {
      if (this.submitting_coordinator_manual_case) return;
      this.dismiss_coordinator_register_modal();
    },
    dismiss_coordinator_register_modal() {
      this.show_coordinator_register_modal = false;
      this.coordinator_manual_case_error = '';
      this.coordinator_manual_case = coordinator_manual_case_form();
      if (this.coordinator_case_type_options[0]?.id) {
        this.coordinator_manual_case.case_type = String(this.coordinator_case_type_options[0].id);
      }
    },
    async submit_coordinator_manual_case() {
      if (this.submitting_coordinator_manual_case) return;

      const selected_case_type = this.coordinator_case_type_options.find(
        (option) => String(option.id) === String(this.coordinator_manual_case.case_type)
      );
      const entity_type_id = to_number(selected_case_type?.id);
      const entity_name = normalize_text(
        this.coordinator_manual_case.description || this.coordinator_manual_case.requester
      );

      if (!entity_type_id || !entity_name) return;

      this.submitting_coordinator_manual_case = true;
      this.coordinator_manual_case_error = '';
      try {
        const form_ids = await resolve_manual_case_form_ids({
          entity_type_id,
          project_id: this.route_project_id,
          fallback_form_ids: selected_case_type.form_ids,
        });
        const create_data = await create_requestor_case({
          entity_name,
          entity_type_id,
          form_ids,
          run_onboarding: true,
          source_channel: 'Walk-in',
          user_email: is_email(this.coordinator_manual_case.contact) ? this.coordinator_manual_case.contact : undefined,
          send_user_email: false,
          ...(this.route_project_id ? { project_id: Number(this.route_project_id) } : {}),
        });
        const created_case = created_manual_case(create_data, entity_type_id);

        this.dismiss_coordinator_register_modal();
        await this.refresh_intake_officer_sidebar_counts();
        if (created_case.application_id && created_case.case_code) {
          this.$router.push({
            name: 'ViewCaseDetails',
            params: { caseCode: created_case.case_code },
            query: Object.fromEntries([
              ['application_id', created_case.application_id],
              ['entity_profile_id', created_case.entity_profile_id],
              ['entity_type_id', created_case.entity_type_id],
              ['project_id', this.route_project_id],
            ].filter(([, value]) => Boolean(value))),
          });
        }
      } catch (error) {
        this.coordinator_manual_case_error = error?.response?.data?.message
          || error?.message
          || 'Failed to register the case.';
      } finally {
        this.submitting_coordinator_manual_case = false;
      }
    },
    close_case_owner_profile_modal() {
      this.show_case_owner_profile_modal = false;
    },
    async handle_case_owner_profile_save(form = {}) {
      const payload = case_owner_profile_update_payload(form, this.case_owner_profile?.edit_profile || {});
      const validation_message = validate_case_owner_profile_payload(payload);

      if (validation_message) {
        this.show_error(validation_message);
        return;
      }

      try {
        await axios.post(UPDATE_USER, payload, get_request_config());
        const full_name = [payload.first_name, payload.last_name].filter(Boolean).join(' ').trim();
        sessionStorage.setItem('user_email', payload.email);
        this.$store.dispatch('setCurrentLeadName', full_name);
        this.case_owner_user_profile = updated_case_owner_user_profile(
          this.case_owner_user_profile,
          payload
        );
        await this.refresh_case_owner_user_profile();
        this.case_owner_profile_save_version += 1;
        this.show_success('Profile updated successfully.');
      } catch (error) {
        this.show_error(error?.response?.data?.message || 'Failed to update profile.');
      }
    },
    has_count(value) {
      return value !== null && value !== undefined && value !== '';
    },
    is_active_route(route_name, route_query = null) {
      return is_active_route(this.$route, route_name, route_query);
    }
  }
};

function coordinator_manual_case_form() {
  return {
    title: 'Register · inbound request',
    subtitle: 'Manual capture · Just now',
    description: '',
    requester: '',
    contact: '',
    location: '',
    case_type: '',
  };
}

function case_requires_attention(case_item = {}) {
  const status = String(case_item?.status || '').toLowerCase();
  const sla = String(case_item?.sla || '').toLowerCase();
  const title = String(case_item?.title || '').toLowerCase();
  const subtitle = String(case_item?.subtitle || '').toLowerCase();
  const update_body = String(case_item?.update_body || '').toLowerCase();

  return (
    sla.includes('overdue')
    || sla.includes('breach')
    || sla.includes('left')
    || status.includes('review')
    || status.includes('due')
    || status.includes('pending')
    || status.includes('awaiting')
    || status.includes('action')
    || title.includes('evidence')
    || subtitle.includes('evidence')
    || update_body.includes('upload')
    || update_body.includes('review')
  );
}

function case_is_in_intake_queue(case_item = {}) {
  const status = String(case_item?.stage || case_item?.status || '').toLowerCase();
  const owner = String(case_item?.owner || case_item?.routed_to || '').trim().toLowerCase();

  const is_unassigned = !owner || owner === 'unassigned' || owner === 'none' || owner === 'na';
  const is_intake_status = (
    status.includes('triage')
    || status.includes('new')
    || status.includes('pending verification')
    || status.includes('pending-verification')
    || status.includes('registered')
  );

  return is_unassigned || is_intake_status;
}

function is_email(value = '') {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}

async function fetch_requestor_sidebar_cases(project_id = null) {
  const entity_types = await fetch_requestor_entity_types(project_filter(project_id));
  const visible_entity_types = (Array.isArray(entity_types) ? entity_types : [])
    .filter((entity_type) => to_number(entity_type?.id));

  if (!visible_entity_types.length) {
    return [];
  }

  const responses = await Promise.all(
    visible_entity_types.map((entity_type) =>
      fetch_requestor_entity_profiles({
        entity_type_id: entity_type.id,
        current_user_only: true,
        page: 1,
        page_size: 500,
        ...project_filter(project_id),
      }).catch(() => ({ data: [] }))
    )
  );

  return responses
    .flatMap((response) => Array.isArray(response?.data) ? response.data : [])
    .map((record) => ({
      status: record_status_label(record),
      title: normalize_text(
        record?.entity_name
        || record?.name
        || record?.profile_name
        || record?.reference_number
      ),
      subtitle: normalize_text(
        record?.workflow_status_name
        || record?.application_status_name
        || record?.current_status_name
      ),
    }))
    .filter((case_item) => is_active_case_status(case_item.status));
}

function case_owner_profile_update_payload(form = {}, current_profile = {}) {
  const payload = {
    user_id: Number(form.user_id || current_profile.user_id || 0),
    first_name: normalize_text(form.first_name),
    last_name: normalize_text(form.last_name),
    email: normalize_text(form.email),
    phone_number: normalize_text(form.phone_number).replace(/\D/g, ''),
  };

  const role_id = Number(form.role_id || current_profile.role_id || 0);
  if (role_id) {
    payload.role_id = role_id;
  }

  return payload;
}

function validate_case_owner_profile_payload(payload = {}) {
  if (!payload.user_id) return 'Unable to identify the current user profile.';
  if (!payload.first_name) return 'First name is required.';
  if (!payload.last_name) return 'Last name is required.';
  if (!is_email(payload.email)) return 'Please enter a valid email address.';
  if (!/^\d{10}$/.test(payload.phone_number)) return 'Mobile must be exactly 10 digits.';
  return '';
}

function updated_case_owner_user_profile(profile = {}, payload = {}) {
  const current_profile = profile || {};
  const current_user = current_profile.user || {};

  return {
    ...current_profile,
    user_id: payload.user_id || current_profile.user_id,
    email: payload.email,
    phone_number: payload.phone_number,
    user: {
      ...current_user,
      id: payload.user_id || current_user.id,
      first_name: payload.first_name,
      last_name: payload.last_name,
      email: payload.email,
      phone_number: payload.phone_number,
      ...(payload.role_id ? { role_id: payload.role_id } : {}),
    },
    ...(payload.role_id ? { role_id: payload.role_id } : {}),
  };
}

async function fetch_panel_member_count(current_role = '') {
  const [users, roles] = await Promise.all([
    fetch_sidebar_panel_users(current_role),
    fetch_sidebar_panel_roles(),
  ]);

  return users
    .map((profile, index) => map_panel_member(profile, index, roles))
    .filter((member) => member.id != null)
    .filter(panel_member_is_allowed)
    .length;
}

async function fetch_sidebar_panel_users(current_role = '') {
  const users = [];
  let page = 1;
  let total_pages = 1;

  do {
    const response = await axios.get(
      GET_USERS,
      get_request_config({ params: { page, page_size: 100, current_role } })
    );
    const pagination = response?.data?.pagination || {};
    users.push(...response_items(response.data));
    total_pages = Number(pagination.total_pages || 1);
    page += 1;
  } while (page <= total_pages);

  return users;
}

async function fetch_sidebar_panel_roles() {
  const response = await axios.get(GET_USER_ROLES, get_request_config());
  return response_items(response.data).map(map_role).filter((role) => role.role);
}

async function fetch_timesheet_count(project_id = null) {
  const sheets = await load_timesheet_sheets(project_filter(project_id));
  const sheet_list = Array.isArray(sheets) ? sheets : [];
  const selected_month = timesheet_months(sheet_list)[0]?.value || '';

  return selected_month
    ? sheet_list.filter((sheet) => sheet.month_key === selected_month).length
    : sheet_list.length;
}

async function fetch_coordinator_inbox_count(component, project_id = null, current_role = '') {
  const cases = await fetch_company_cases(project_id);
  if (!Array.isArray(cases)) {
    return null;
  }

  const assigned_cases = is_coordinator_role(current_role)
    ? await fetch_coordinator_assigned_company_cases(project_id).catch(() => [])
    : [];
  const mention_lookup_cases = unique_cases([...cases, ...assigned_cases]);
  const mention_count = await fetch_sidebar_mention_count(component, mention_lookup_cases).catch(() => 0);

  return visible_cases_for_role(cases, current_role).length + mention_count;
}

async function fetch_sidebar_mention_count(component, cases = []) {
  const viewer_user_id = inbox_current_user_id(component);
  const mention_counts = await Promise.all(unique_cases(cases).map(async (case_item) => {
    const application_id = Number(case_item?.application_id || 0);
    const mention_tokens = current_user_mention_tokens(component, case_item);

    if (!application_id || !mention_tokens.length) {
      return 0;
    }

    const notes = await fetch_requestor_application_notes(application_id).catch(() => []);
    return (Array.isArray(notes) ? notes : [])
      .filter((note) => !note_authored_by_current_user(note, viewer_user_id, mention_tokens))
      .filter((note) => note_mentions_current_user(note, mention_tokens))
      .length;
  }));

  return mention_counts.reduce((total, count) => total + Number(count || 0), 0);
}

function project_filter(project_id = null) {
  return project_id ? { project_id } : {};
}

